export enum AutogiroMandateStatusEnum {
  New = 10,
  PendingApproval = 30,
  NotApproved = 40,
  Approved = 50,
  PendingCancel = 60,
  Canceled = 70,
  Error = 90,
  Unknown = 0,
}

export const AutogiroMandateStatusDescription = (method: AutogiroMandateStatusEnum, t: (n: string) => string): string => {
  const translationKeys: Record<AutogiroMandateStatusEnum, string> = {
    [AutogiroMandateStatusEnum.New]: t('invoice:autogiroMandateStatus.New'),
    [AutogiroMandateStatusEnum.PendingApproval]: t('invoice:autogiroMandateStatus.PendingApproval'),
    [AutogiroMandateStatusEnum.NotApproved]: t('invoice:autogiroMandateStatus.NotApproved'),
    [AutogiroMandateStatusEnum.Approved]: t('invoice:autogiroMandateStatus.Approved'),
    [AutogiroMandateStatusEnum.PendingCancel]: t('invoice:autogiroMandateStatus.PendingCancel'),
    [AutogiroMandateStatusEnum.Canceled]: t('invoice:autogiroMandateStatus.Canceled'),
    [AutogiroMandateStatusEnum.Error]: t('invoice:autogiroMandateStatus.Error'),
    [AutogiroMandateStatusEnum.Unknown]: t('invoice:autogiroMandateStatus.Unknown'),
  };

  const key = translationKeys[method] || 'invoice:autogiroMandateStatus.Unknown';
  return t(key);
};
